export const blockIconsTransportationDirectionsRunNew = (
	<span className='material-symbols-outlined'>directions_run</span>
);
